import constants from "@/config/config.js";
import FilePdf from "vue-material-design-icons/FilePdf.vue";

export default {
  components: {
    "file-pdf-icon": FilePdf
  },
  data() {
    return {
      recibos: null,
      items: [],
      fields: [
        { key: "unidad", label: "Unidad" },
        { key: "fecha", label: "Fecha de creación" },
        { key: "ruta", label: "Ruta" },
        { key: "accion", label: "Acción" }
      ],
      perPage: 10,
      selectedChofer: false,
      selectedEconomico: false,
      selectedFecha: false,
      selectedRuta: false,
      filterChofer: "",
      filterEconomico: "",
      filterFecha: "",
      filterRuta: "",
      choferes: [],
      chofer: null,
      numEconomicos: [],
      numero: null,
      isBusy: false,
      isEmpty: false,
      isDisabled: false,
      disabledDropdownChofer: false,
      disabledDropdownEconomicos: false,
      rows: 1,
      currentPage: 1
    };
  },
  // Antes de que se cree el componente, se ejecuta el método de obtener recibos
  mounted() {
    this.getChoferes();
    this.getNumEconomicos();
    this.getRecibos();
  },
  watch: {
    currentPage: {
      handler: function() {
        this.getRecibos();
      }
    },
    filterFecha: {
      handler: function() {
        if (this.selectedFecha) {
          this.getRecibos();
        }
      }
    },
    selectedFecha: {
      handler: function() {
        this.getRecibos();
      }
    },
    filterEconomico: {
      handler: function() {
        if (this.selectedEconomico) {
          this.getRecibos();
        }
      }
    },
    selectedEconomico: {
      handler: function() {
        if (this.filterEconomico === this.numero) {
          this.getRecibos();
        } else {
          this.filterEconomico = this.numero;
        }
      }
    },
    filterRuta: {
      handler: function() {
        if (this.selectedRuta) {
          this.getRecibos();
        }
      }
    },
    selectedRuta: {
      handler: function() {
        this.getRecibos();
      }
    },
    filterChofer: {
      handler: function() {
        if (this.selectedChofer) {
          this.getRecibos();
        }
      }
    },
    selectedChofer: {
      handler: function() {
        if (this.filterChofer === this.chofer.nombre) {
          this.getRecibos();
        }
      }
    }
  },
  computed: {
    // Devuelve el filtro correspondiente dependiendo del checkbox que se esté seleccionando
    filter() {
      if (this.selectedFecha) {
        return this.filterFecha;
      } else if (this.selectedRuta) {
        return this.filterRuta;
      } else if (this.selectedChofer) {
        this.filterChofer = this.chofer.nombre;
        return this.filterChofer;
      } else if (this.selectedEconomico) {
        this.filterEconomico = this.numero;
        return this.filterEconomico;
      }
    }
  },
  methods: {
    // Get de recibos dependiendo el id del socio
    async getRecibos() {
      this.items = [];
      // Mostrar mensaje de cargando en la página si es que no se muestran los datos aún en la tabla
      this.isBusy = true;
      this.isDisabled = true;
      let choferId = this.choferes.filter(
        choferes => choferes.nombre === this.chofer.nombre
      );
      let filterIdChofer;
      if (!this.selectedChofer) {
        filterIdChofer = "";
      } else {
        filterIdChofer = choferId[0].id;
      }

      if (!this.selectedEconomico) {
        this.filterEconomico = "";
      } else {
        this.filterEconomico = this.numero;
      }

      if (!this.selectedRuta) {
        this.filterRuta = "";
      }

      if (!this.selectedFecha) {
        this.filterFecha = "";
      }
      const { status, data } = await this.Api.get(
        `recibos?perPage=${this.perPage}&page=${this.currentPage}&fecha=${this.filterFecha}&economico=${this.filterEconomico}&ruta=${this.filterRuta}&choferId=${filterIdChofer}`
      );
      if (status) {
        this.rows = data.total;
        this.recibos = data.data;
        this.recibos.sort(this.orderArrayOfObjects("economico"));
        this.recibos.forEach(recibo => {
          // Los datos de la columa Unidad se forman con el número económico y el nombre del chofer
          let unidad = `${recibo.economico} - ${recibo.choferNombre}  ${recibo.choferApellidoPaterno}`;
          recibo = {
            ruta: recibo.ruta,
            fecha: recibo.fechaCreacion,
            unidad,
            accion: `${constants.apiEndPoint}${recibo.rutaPDF}`
          };
          this.items.push(recibo);
        });
        if (
          this.items.length === 0 &&
          !this.selectedRuta &&
          !this.selectedFecha &&
          !this.selectedEconomico &&
          !this.selectedChofer
        ) {
          this.isEmpty = true;
          this.isDisabled = true;
          this.disabledDropdownEconomicos = true;
          this.disabledDropdownChofer = true;
        } else if (
          (this.items.length === 0 && this.selectedRuta) ||
          this.selectedFecha ||
          this.selectedEconomico ||
          this.selectedChofer
        ) {
          this.isEmpty = true;
          this.isDisabled = false;
        } else {
          this.isEmpty = false;
          this.disabledDropdownEconomicos = false;
          this.disabledDropdownChofer = false;
          this.isDisabled = false;
        }
      }
      this.isBusy = false;
    },
    async getChoferes() {
      let idChoferes = [];
      this.disabledDropdownChofer = true;
      const { status, data } = await this.Api.get(`choferes?perPage=100`);
      if (status) {
        let choferes = data.data;
        choferes.forEach(chofer => {
          let nombreChofer = `${chofer.nombres}  ${chofer.apellidoPaterno}`;
          idChoferes.push({
            id: chofer.id,
            nombre: nombreChofer
          });
        });
        if (idChoferes.length === 0) {
          this.disabledDropdownChofer = true;
        } else {
          this.disabledDropdownChofer = false;
          // Array de choferes es filtrado y ordenado para ponerlo de esa manera en el dropdown
          this.choferes = this.filterArrayOfObjects(idChoferes);
          this.choferes.sort(this.orderArrayOfObjects("nombre"));
          this.filterChofer = this.choferes[0].nombre;
          this.chofer = this.choferes[0];
        }
      }
    },
    async getNumEconomicos() {
      this.disabledDropdownEconomicos = true;
      let numEconomicoArray = [];
      const { status, data } = await this.Api.get(`unidades?perPage=100000`);
      if (status) {
        let unidades = data.data;
        unidades.forEach(unidad => {
          numEconomicoArray.push(unidad.economico);
        });
        if (numEconomicoArray.length === 0) {
          this.disabledDropdownEconomicos = true;
        } else {
          this.disabledDropdownEconomicos = false;
          // Array de números económicos es filtrado y ordenado para ponerlo de esa manera en el dropdown
          this.numEconomicos = this.filterAndOrderArray(numEconomicoArray);
          this.numero = this.numEconomicos[0].toString();
        }
      }
    },
    showTextChofer(chofer) {
      this.filterChofer = chofer.nombre;
      this.chofer = chofer;
    },
    showTextEconomico(num) {
      this.numero = num.toString();
      this.filterEconomico = this.numero;
    },
    filterAndOrderArray(items) {
      let array = items
        .filter((x, i, a) => a.indexOf(x) == i)
        .sort((a, b) => a - b);
      return array;
    },
    filterArrayOfObjects(items) {
      let distinctArray = Array.from(new Set(items.map(s => s.id))).map(id => {
        return {
          id: id,
          nombre: items.find(s => s.id === id).nombre
        };
      });
      return distinctArray;
    },
    orderArrayOfObjects(key, order = "asc") {
      return function innerSort(a, b) {
        if (
          !Object.prototype.hasOwnProperty.call(a, key) ||
          !Object.prototype.hasOwnProperty.call(b, key)
        ) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },
    // Abre una nueva ventana con la ruta que se le pase
    // En este caso se utiliza para los botones que muestran los PDF de los recibos
    sendTo(ruta) {
      window.open(ruta);
    }
  }
};
